import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = { class: "my-8" }
const _hoisted_3 = { class: "my-8" }
const _hoisted_4 = { class: "my-8" }
const _hoisted_5 = { class: "my-8" }
const _hoisted_6 = { class: "my-8" }
const _hoisted_7 = { class: "my-8" }
const _hoisted_8 = { class: "my-8" }
const _hoisted_9 = { class: "my-8" }
const _hoisted_10 = { class: "d-flex align-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_form, {
      modelValue: _ctx.isFormValid,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.isFormValid) = $event))
    }, {
      default: _withCtx(() => [
        _cache[22] || (_cache[22] = _createElementVNode("div", { class: "mb-8" }, [
          _createElementVNode("h1", null, "児童アカウント 新規作成")
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _cache[13] || (_cache[13] = _createElementVNode("h4", null, "園児区分*", -1)),
          _createVNode(_component_v_select, {
            rules: [_ctx.required],
            variant: "outlined",
            density: "compact",
            "hide-details": "",
            items: _ctx.childTypeOptions,
            "item-title": "label",
            "item-value": "value",
            modelValue: _ctx.childcareType,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.childcareType) = $event)),
            color: "primary"
          }, null, 8, ["rules", "items", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _cache[14] || (_cache[14] = _createElementVNode("h4", { class: "mb-2" }, "氏名*", -1)),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "6" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    variant: "outlined",
                    density: "compact",
                    "hide-details": "",
                    label: "姓",
                    modelValue: _ctx.lastName,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.lastName) = $event)),
                    rules: [_ctx.required],
                    color: "primary"
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "6" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    variant: "outlined",
                    density: "compact",
                    "hide-details": "",
                    label: "名",
                    modelValue: _ctx.firstName,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.firstName) = $event)),
                    rules: [_ctx.required],
                    color: "primary"
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "6" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    variant: "outlined",
                    density: "compact",
                    "hide-details": "",
                    label: "姓 (カタカナ)",
                    modelValue: _ctx.lastNameKana,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.lastNameKana) = $event)),
                    rules: [_ctx.required, _ctx.isKatakana],
                    color: "primary"
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "6" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    variant: "outlined",
                    density: "compact",
                    "hide-details": "",
                    label: "名 (カタカナ)",
                    modelValue: _ctx.firstNameKana,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.firstNameKana) = $event)),
                    rules: [_ctx.required, _ctx.isKatakana],
                    color: "primary"
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[15] || (_cache[15] = _createElementVNode("h4", { class: "mb-2" }, "園で管理しているコード/番号 (自由記入)", -1)),
          _createVNode(_component_v_text_field, {
            variant: "outlined",
            density: "compact",
            "hide-details": "",
            label: "任意コード1",
            modelValue: _ctx.optionalChildCode1,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.optionalChildCode1) = $event)),
            class: "mb-2",
            color: "primary"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_v_text_field, {
            variant: "outlined",
            density: "compact",
            "hide-details": "",
            label: "任意コード2",
            modelValue: _ctx.optionalChildCode2,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.optionalChildCode2) = $event)),
            color: "primary"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[16] || (_cache[16] = _createElementVNode("h4", { class: "mb-2" }, "生年月日*", -1)),
          _createVNode(_component_v_text_field, {
            rules: [_ctx.required],
            variant: "outlined",
            density: "compact",
            "hide-details": "",
            type: "date",
            label: "生年月日",
            modelValue: _ctx.dateOfBirth,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dateOfBirth) = $event)),
            color: "primary"
          }, null, 8, ["rules", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[17] || (_cache[17] = _createElementVNode("h4", { class: "mb-2" }, "性別*", -1)),
          _createVNode(_component_v_select, {
            rules: [_ctx.required],
            variant: "outlined",
            density: "compact",
            "hide-details": "",
            items: _ctx.genderOptions,
            "item-title": "label",
            "item-value": "value",
            modelValue: _ctx.gender,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.gender) = $event)),
            color: "primary"
          }, null, 8, ["rules", "items", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[18] || (_cache[18] = _createElementVNode("h4", { class: "mb-2" }, "入園日 (予定)*", -1)),
          _createVNode(_component_v_text_field, {
            rules: [_ctx.required],
            variant: "outlined",
            density: "compact",
            "hide-details": "",
            type: "date",
            label: "入園日",
            modelValue: _ctx.admissionDate,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.admissionDate) = $event)),
            color: "primary"
          }, null, 8, ["rules", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _cache[19] || (_cache[19] = _createElementVNode("h4", { class: "mb-2" }, "卒園日 (予定)", -1)),
          _createVNode(_component_v_text_field, {
            variant: "outlined",
            density: "compact",
            "hide-details": "",
            type: "date",
            label: "卒園日",
            modelValue: _ctx.graduationDate,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.graduationDate) = $event)),
            color: "primary"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _cache[20] || (_cache[20] = _createElementVNode("h4", null, "延長保育パターン", -1)),
          _createVNode(_component_v_select, {
            modelValue: _ctx.hoursPatternId,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.hoursPatternId) = $event)),
            items: _ctx.patternList,
            "item-title": "patternTitle",
            "item-value": "patternId",
            variant: "outlined",
            density: "compact",
            "hide-details": "",
            color: "primary"
          }, null, 8, ["modelValue", "items"])
        ]),
        _createElementVNode("div", null, [
          (_ctx.isCreating)
            ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                key: 0,
                indeterminate: "",
                color: "primary",
                class: "my-8"
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_btn, {
            color: "primary",
            variant: "flat",
            "x-large": "",
            onClick: _ctx.create,
            disabled: _ctx.isCreating || !_ctx.isFormValid
          }, {
            default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
              _createTextVNode("保存", -1)
            ]))]),
            _: 1
          }, 8, ["onClick", "disabled"]),
          _createVNode(_component_v_spacer)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}